import { render, staticRenderFns } from "./OrderListOrderItem.vue?vue&type=template&id=61770a05&"
import script from "./OrderListOrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderListOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports